import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FORGET_PASSWORD_INPUT,
  FORGET_PASSWORD_RESPONSE,
  UPDATE_PASSWORD_INPUT,
  UPDATE_PASSWORD_RESPONSE,
  VERFICATION_RESET_INPUT,
  VERIFY_SIGNUP_INPUT,
  RESEND_INPUT,
} from '../../model/login';
import { RESPONCE } from '../../model/responce';
import {
  PHASE_ONE_INPUT,
  PHASE_RESPONSE,
  BUSINESS_TYPE_INPUT,
  BUSINESS_TYPE_RESPONSE,
} from '../../model/signUp.model';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class AutoRegistrationService {
  constructor(private readonly apiService: ApiService) {}

  /** Requests a password reset email/code for the given account identifier. */
  forgetPassword(
    data: FORGET_PASSWORD_INPUT
  ): Observable<RESPONCE<FORGET_PASSWORD_RESPONSE>> {
    return this.apiService.post<
      FORGET_PASSWORD_INPUT,
      RESPONCE<FORGET_PASSWORD_RESPONSE>
    >('v2/Auth/ForgetPassword', data);
  }

  /** Completes password reset with the new password and verification payload. */
  updatePassword(
    data: UPDATE_PASSWORD_INPUT
  ): Observable<RESPONCE<UPDATE_PASSWORD_RESPONSE>> {
    return this.apiService.post<
      UPDATE_PASSWORD_INPUT,
      RESPONCE<UPDATE_PASSWORD_RESPONSE>
    >('v2/Auth/ResetPassword', data);
  }

  /** Verifies a reset/verification code (generic auth verify endpoint). */
  verification(data: VERFICATION_RESET_INPUT): Observable<RESPONCE<boolean>> {
    return this.apiService.post<VERFICATION_RESET_INPUT, RESPONCE<boolean>>(
      'v2/Auth/VerifyCode',
      data
    );
  }

  /** Verifies the signup mobile number during registration phase one. */
  verificationPhaseOne(data: VERIFY_SIGNUP_INPUT): Observable<RESPONCE<any>> {
    return this.apiService.post<VERIFY_SIGNUP_INPUT, any>(
      'RegistrationCyclePhaseOne/VerifyMobileNumber',
      data
    );
  }

  /** Saves phase-one signup data (user profile) on the registration cycle. */
  signUpPhaseOne(data: PHASE_ONE_INPUT): Observable<RESPONCE<PHASE_RESPONSE>> {
    return this.apiService.post<PHASE_ONE_INPUT, RESPONCE<PHASE_RESPONSE>>(
      'RegistrationCyclePhaseOne/SavePhaseOneData',
      data
    );
  }

  /** Saves phase-two business type and related fields for the registration cycle. */
  saveBusinessType(
    data: BUSINESS_TYPE_INPUT
  ): Observable<RESPONCE<BUSINESS_TYPE_RESPONSE>> {
    return this.apiService.post<
      BUSINESS_TYPE_INPUT,
      RESPONCE<BUSINESS_TYPE_RESPONSE>
    >('RegistrationCyclePhaseTwo/SavePhaseTwoData', data);
  }

  /** Resends the SMS/email verification code for phase-one mobile verification. */
  resendCode(data: RESEND_INPUT): Observable<any> {
    return this.apiService.post<any, any>(
      'RegistrationCyclePhaseOne/SendVerificationCode',
      data
    );
  }
}
